import React from 'react'
import Header from './header';
import Modal from './modal'
import Toast from "./Toast/toast"

const PageLayout = ({
        children,
        Map = null,
        fullWidth = false,
        bgWhite = false,
        bgImage = false,
        pad = true,
        headerbg = `#feec6b`,
        bgStore=false
    }) => (
    <div className="h100p">
        <Header headerbg={headerbg}/>
        {!fullWidth && Map && <Map />}
        <div className={`page-content ${pad ? 'page-pad' : ''} ${bgWhite ? 'background-white' : ''} ${fullWidth? 'without-map': 'with-map'} ${bgImage ? 'background-image' : ''} ${bgStore ? 'storebg' : ''}`.trim()}>
            {children}  
        </div>
        <Modal />
        <Toast />
    </div>
)

export default PageLayout
